<<<<<<< HEAD
<template>
     <v-layout>
        <v-navigation-drawer
          v-model="showDraw"
          absolute
          temporary>
          <div v-for="item in items"   >
            <v-list class="pa-1">
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="/static/logistique.png">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>{{item.title}}</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>

            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-tile
                v-for="sousMenu in item.sousMenus"
                @click="switchFonction(sousMenu.action)">
                <v-list-tile-action>
                    <v-icon>{{sousMenu.icon}}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>{{sousMenu.title}}</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>
          </div>

          
        </v-navigation-drawer>
          <!-- Carte carburants index -->
            <CarteCarburantIndex :show = "showDialogCarburant" @close="showDialogCarburant = false;"    ></CarteCarburantIndex>
         <!-- Carte carburants  index -->
      </v-layout>

    
</template>

<script>
 import CarteCarburantIndex from "@/components/carteCarburant/CarteCarburant_index";
export default {
    name: "menuDrawer",
    components:{CarteCarburantIndex},
    props:{
        drawer:{
            type:Boolean,
            default: null
        }
    },
    data(){
        return {
        items: [
            {
                title:"Logistique",
                icon:"directions_bus",
                sousMenus: [{
                    title: "Carte Carburant",
                    icon:"credit_card",
                    action:"carteCarburant"
                },
                ]
            }
        ],
        showDrawer: null,
        showDialogCarburant: false,
        }
    },
    watch:{
        drawer: function(newValue,oldValue){
                 this.showDrawer = newValue  
        }
    },
   computed:{
        showDraw: 
        {
            get:function(){
                return this.showDrawer
            },
            set: function(newValue)
            {
                 if(newValue == false) {
                    this.$emit("close");
                } 
            }        
        }
   },
    methods: 
    {
        switchFonction(fonction){
            switch(fonction){
                case "carteCarburant":
                    this.carteCarburant();
                break;
            }
        },
        carteCarburant()
        {
            this.showDialogCarburant = true;
        }
    }    
}
</script>
=======
<template>
     <v-layout>
        <v-navigation-drawer
          v-model="showDraw"
          absolute
          temporary>
          <div v-for="item in items"   >
            <v-list class="pa-1">
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="/static/logistique.png">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>{{item.title}}</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>

            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-tile
                v-for="sousMenu in item.sousMenus"
                :key=""
                @click="switchFonction(sousMenu.action)">
                <v-list-tile-action>
                    <v-icon>{{sousMenu.icon}}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>{{sousMenu.title}}</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>
          </div>

          
        </v-navigation-drawer>
          <!-- Carte carburants index -->
            <CarteCarburantIndex :show = "showDialogCarburant" @close="showDialogCarburant = false;"    ></CarteCarburantIndex>
         <!-- Carte carburants  index -->
      </v-layout>

    
</template>

<script>
 import CarteCarburantIndex from "@/components/carteCarburant/CarteCarburant_index";
export default {
    name: "menuDrawer",
    components:{CarteCarburantIndex},
    props:{
        drawer:{
            type:Boolean,
            default: null
        }
    },
    data(){
        return {
        items: [
            {
                title:"Logistique",
                icon:"directions_bus",
                sousMenus: [{
                    title: "Carte Carburant",
                    icon:"credit_card",
                    action:"carteCarburant"
                },
                ]
            }
        ],
        showDrawer: null,
        showDialogCarburant: false,
        }
    },
    watch:{
        drawer: function(newValue,oldValue){
                 this.showDrawer = newValue  
        }
    },
   computed:{
        showDraw: 
        {
            get:function(){
                return this.showDrawer
            },
            set: function(newValue)
            {
                 if(newValue == false) {
                    this.$emit("close");
                } 
            }        
        }
   },
    methods: 
    {
        switchFonction(fonction){
            switch(fonction){
                case "carteCarburant":
                    this.carteCarburant();
                break;
            }
        },
        carteCarburant()
        {
            this.showDialogCarburant = true;
        }
    }    
}
</script>
>>>>>>> b63aeeaa06fe9842bee6ab2aa24e53a6f94ae439



// WEBPACK FOOTER //
// src/components/menu/Drawer.vue